"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabeledControl = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LabeledControlMixin = require("../../mixins/components/LabeledControlMixin");
var StyledLabeledControl = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledLabeledControl",
  componentId: "c11n-8-107-0__sc-47exur-0"
})(["", ""], _LabeledControlMixin.LabeledControlMixin);
exports.StyledLabeledControl = StyledLabeledControl;